import toast from 'react-hot-toast';

export const showSuccessMessage = (message = "Operation successful") => {
  toast.success(message, {
    style: {
      background: '#333',
      color: '#fff',
    },
  });
};

export const showAxiosError = (error, defaultMessage = "An unexpected error occurred. Please try again.") => {
  let message = defaultMessage;

  if (error.response?.data?.message) {
    message = error.response.data.message;
  } else if (error.message) {
    message = error.message;
  }

  toast.error(message, {
    style: {
      background: '#ef4444',
      color: '#fff',
    },
  });
};




